import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 1em 0;\n  min-height: 12px;\n'], ['\n  margin: 1em 0;\n  min-height: 12px;\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject);